import { NgModule } from '@angular/core';
import {PortalWelcomeComponent} from "./portal-welcome/portal-welcome.component";
import { PortalPlaceholderComponent } from './portal-placeholder/portal-placeholder.component';
import { PortalDebugComponent } from './portal-debug/portal-debug.component';
import {CommonModule} from "@angular/common";
import { PortalRestrictedComponent } from './portal-restricted/portal-restricted.component';

/**
 * These are components that may be used in an Angular dynamic portal template.
 */
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PortalWelcomeComponent,
    PortalPlaceholderComponent,
    PortalDebugComponent,
    PortalRestrictedComponent,
  ],
  providers: [
  ],
  exports: [
    PortalWelcomeComponent,
    PortalPlaceholderComponent,
    PortalDebugComponent,
    PortalRestrictedComponent,
  ]
})
export class PortalDynamicModule {}
